import React from "react";

const ChatProfileCard = ({ props, unseenMsgCountData, onClick }) => {

    // console.log(props);

    return (
        <>
            <div className="chat_card" onClick={onClick}>
                <div className="chat_profile">
                    <img
                        src={props.user.profileImage_path}
                        alt="profile_image"
                        height="40px"
                        width="40px"
                        className="profileLogo"
                    />
                </div>
                <div className="message_container">
                    <div className="chat_name_container">
                        <p className="chat_name">{props.user.displayName}</p>
                        <span
                            className="unread_message_count"
                        style={{ display: unseenMsgCountData.get(props.user.email) || 0 ? "" : "none" }}
                        >
                            {unseenMsgCountData.get(props.user.email) || 0}
                        </span>
                    </div>
                    <span className="chat_message">
                        {props.data.last_msg && props.data.last_msg.length > 35
                            ? props.data.last_msg.slice(0, 35) + `...`
                            : props.data.last_msg}
                    </span>
                </div>
            </div>
        </>
    );
};

export default ChatProfileCard;
